export const GET_LOCATION_REQUEST = "GET_LOCATION_REQUEST";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_FAILURE = "GET_LOCATION_FAILURE";

export const CHOOSE_LOCATION_REQUEST = "CHOOSE_LOCATION_REQUEST";
export const CHOOSE_LOCATION_SUCCESS = "CHOOSE_LOCATION_SUCCESS";
export const CHOOSE_LOCATION_FAILURE = "CHOOSE_LOCATION_FAILURE";
